export default __webpack_public_path__ + "static/media/sounds/maze_model_option_work.mp3";